import { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { CounterProps } from './counter.types';
import { StyledCounter } from './counter.styled';
import { Text } from '../text';

export const Counter = observer(
  forwardRef<HTMLSpanElement, CounterProps>(
    (
      {
        size = 'm',
        variant = 'main',
        color = 'primary',
        count = 0,
        overflowCount = 99,
        isDot = false,
        ...restProps
      },
      forwardedRef
    ) => {
      if (count < 0) {
        return null;
      }

      return (
        <StyledCounter
          ref={forwardedRef}
          $size={size}
          $variant={variant}
          $color={color}
          $isDot={isDot}
          {...restProps}
        >
          {!isDot && (
            <Text
              variant={size === 's' ? 'caption-11' : 'caption-13'}
              style={{ whiteSpace: 'nowrap' }}
            >
              {count > overflowCount ? `${overflowCount}+` : count}
            </Text>
          )}
        </StyledCounter>
      );
    }
  )
);
